module.exports = __webpack_public_path__ + "media/research2.025ffaf7.wav";